export const dependencies = [
  {
    label: "dynatrace",
    value: "dynatrace",
  },
  {
    label: "actuator",
    value: "actuator",
  },
  {
    label: "data-redis-reactive",
    value: "data-redis-reactive",
  },
  {
    label: "camel",
    value: "camel",
  },
  {
    label: "cloud-contract-stub-runner",
    value: "cloud-contract-stub-runner",
  },
  {
    label: "validation",
    value: "validation",
  },
  {
    label: "azure-support",
    value: "azure-support",
  },
  {
    label: "modulith",
    value: "modulith",
  },
  {
    label: "cloud-starter-zookeeper-config",
    value: "cloud-starter-zookeeper-config",
  },
  {
    label: "cache",
    value: "cache",
  },
  {
    label: "spring-shell",
    value: "spring-shell",
  },
  {
    label: "zipkin",
    value: "zipkin",
  },
  {
    label: "data-rest-explorer",
    value: "data-rest-explorer",
  },
  {
    label: "codecentric-spring-boot-admin-client",
    value: "codecentric-spring-boot-admin-client",
  },
  {
    label: "azure-keyvault",
    value: "azure-keyvault",
  },
  {
    label: "data-cassandra",
    value: "data-cassandra",
  },
  {
    label: "cloud-starter-consul-discovery",
    value: "cloud-starter-consul-discovery",
  },
  {
    label: "kafka",
    value: "kafka",
  },
  {
    label: "azure-active-directory",
    value: "azure-active-directory",
  },
  {
    label: "oauth2-authorization-server",
    value: "oauth2-authorization-server",
  },
  {
    label: "integration",
    value: "integration",
  },
  {
    label: "scs-config-client",
    value: "scs-config-client",
  },
  {
    label: "cloud-config-server",
    value: "cloud-config-server",
  },
  {
    label: "vaadin",
    value: "vaadin",
  },
  {
    label: "freemarker",
    value: "freemarker",
  },
  {
    label: "native",
    value: "native",
  },
  {
    label: "web",
    value: "web",
  },
  {
    label: "data-cassandra-reactive",
    value: "data-cassandra-reactive",
  },
  {
    label: "hsql",
    value: "hsql",
  },
  {
    label: "pulsar-reactive",
    value: "pulsar-reactive",
  },
  {
    label: "datadog",
    value: "datadog",
  },
  {
    label: "groovy-templates",
    value: "groovy-templates",
  },
  {
    label: "data-couchbase-reactive",
    value: "data-couchbase-reactive",
  },
  {
    label: "devtools",
    value: "devtools",
  },
  {
    label: "graphql",
    value: "graphql",
  },
  {
    label: "activemq",
    value: "activemq",
  },
  {
    label: "oauth2-client",
    value: "oauth2-client",
  },
  {
    label: "testcontainers",
    value: "testcontainers",
  },
  {
    label: "cloud-starter",
    value: "cloud-starter",
  },
  {
    label: "amqp",
    value: "amqp",
  },
  {
    label: "rsocket",
    value: "rsocket",
  },
  {
    label: "cloud-task",
    value: "cloud-task",
  },
  {
    label: "cloud-bus",
    value: "cloud-bus",
  },
  {
    label: "kafka-streams",
    value: "kafka-streams",
  },
  {
    label: "cloud-resilience4j",
    value: "cloud-resilience4j",
  },
  {
    label: "db2",
    value: "db2",
  },
  {
    label: "unboundid-ldap",
    value: "unboundid-ldap",
  },
  {
    label: "data-ldap",
    value: "data-ldap",
  },
  {
    label: "okta",
    value: "okta",
  },
  {
    label: "solace",
    value: "solace",
  },
  {
    label: "data-neo4j",
    value: "data-neo4j",
  },
  {
    label: "data-rest",
    value: "data-rest",
  },
  {
    label: "new-relic",
    value: "new-relic",
  },
  {
    label: "mail",
    value: "mail",
  },
  {
    label: "distributed-tracing",
    value: "distributed-tracing",
  },
  {
    label: "cloud-stream",
    value: "cloud-stream",
  },
  {
    label: "graphite",
    value: "graphite",
  },
  {
    label: "docker-compose",
    value: "docker-compose",
  },
  {
    label: "liquibase",
    value: "liquibase",
  },
  {
    label: "azure-cosmos-db",
    value: "azure-cosmos-db",
  },
  {
    label: "websocket",
    value: "websocket",
  },
  {
    label: "derby",
    value: "derby",
  },
  {
    label: "mysql",
    value: "mysql",
  },
  {
    label: "data-couchbase",
    value: "data-couchbase",
  },
  {
    label: "cloud-starter-consul-config",
    value: "cloud-starter-consul-config",
  },
  {
    label: "web-services",
    value: "web-services",
  },
  {
    label: "cloud-loadbalancer",
    value: "cloud-loadbalancer",
  },
  {
    label: "oracle",
    value: "oracle",
  },
  {
    label: "configuration-processor",
    value: "configuration-processor",
  },
  {
    label: "flyway",
    value: "flyway",
  },
  {
    label: "batch",
    value: "batch",
  },
  {
    label: "data-jpa",
    value: "data-jpa",
  },
  {
    label: "hilla",
    value: "hilla",
  },
  {
    label: "thymeleaf",
    value: "thymeleaf",
  },
  {
    label: "cloud-eureka",
    value: "cloud-eureka",
  },
  {
    label: "data-jdbc",
    value: "data-jdbc",
  },
  {
    label: "lombok",
    value: "lombok",
  },
  {
    label: "cloud-starter-vault-config",
    value: "cloud-starter-vault-config",
  },
  {
    label: "codecentric-spring-boot-admin-server",
    value: "codecentric-spring-boot-admin-server",
  },
  {
    label: "data-redis",
    value: "data-redis",
  },
  {
    label: "wavefront",
    value: "wavefront",
  },
  {
    label: "pulsar",
    value: "pulsar",
  },
  {
    label: "cloud-starter-zookeeper-discovery",
    value: "cloud-starter-zookeeper-discovery",
  },
  {
    label: "session",
    value: "session",
  },
  {
    label: "mybatis",
    value: "mybatis",
  },
  {
    label: "webflux",
    value: "webflux",
  },
  {
    label: "data-r2dbc",
    value: "data-r2dbc",
  },
  {
    label: "data-mongodb",
    value: "data-mongodb",
  },
  {
    label: "jdbc",
    value: "jdbc",
  },
  {
    label: "h2",
    value: "h2",
  },
  {
    label: "cloud-contract-verifier",
    value: "cloud-contract-verifier",
  },
  {
    label: "mustache",
    value: "mustache",
  },
  {
    label: "cloud-gateway",
    value: "cloud-gateway",
  },
  {
    label: "data-mongodb-reactive",
    value: "data-mongodb-reactive",
  },
  {
    label: "cloud-gcp-pubsub",
    value: "cloud-gcp-pubsub",
  },
  {
    label: "cloud-feign",
    value: "cloud-feign",
  },
  {
    label: "security",
    value: "security",
  },
  {
    label: "sqlserver",
    value: "sqlserver",
  },
  {
    label: "postgresql",
    value: "postgresql",
  },
  {
    label: "jersey",
    value: "jersey",
  },
  {
    label: "jooq",
    value: "jooq",
  },
  {
    label: "hateoas",
    value: "hateoas",
  },
  {
    label: "scs-service-registry",
    value: "scs-service-registry",
  },
  {
    label: "prometheus",
    value: "prometheus",
  },
  {
    label: "oauth2-resource-server",
    value: "oauth2-resource-server",
  },
  {
    label: "sentry",
    value: "sentry",
  },
  {
    label: "data-elasticsearch",
    value: "data-elasticsearch",
  },
  {
    label: "artemis",
    value: "artemis",
  },
  {
    label: "influx",
    value: "influx",
  },
  {
    label: "restdocs",
    value: "restdocs",
  },
  {
    label: "quartz",
    value: "quartz",
  },
  {
    label: "cloud-gcp-storage",
    value: "cloud-gcp-storage",
  },
  {
    label: "cloud-function",
    value: "cloud-function",
  },
  {
    label: "mariadb",
    value: "mariadb",
  },
  {
    label: "azure-storage",
    value: "azure-storage",
  },
  {
    label: "cloud-eureka-server",
    value: "cloud-eureka-server",
  },
  {
    label: "cloud-gcp",
    value: "cloud-gcp",
  },
  {
    label: "cloud-config-client",
    value: "cloud-config-client",
  },
];

export const dependenciesByCategory = [
  {
    category: "Developer Tools",
    items: [
      {
        label: "Spring Boot DevTools",
        value: "devtools",
        description:
          "Provides fast application restarts, LiveReload, and configurations for enhanced development experience.",
      },
      {
        label: "Spring Modulith",
        value: "modulith",
        description: "Support for building modular monolithic applications.",
      },
      {
        label: "Native",
        value: "native",
        description:
          "Support for compiling Spring applications to native executables using the GraalVM native-image compiler.",
      },
      {
        label: "Docker Compose Support",
        value: "docker-compose",
        description:
          "Provides docker compose support for enhanced development experience.",
      },
      {
        label: "Spring Configuration Processor",
        value: "configuration-processor",
        description:
          "Generate metadata for developers to offer contextual help and 'code completion' when working with custom configuration keys (ex.application.properties/.yml files).",
      },
      {
        label: "Lombok",
        value: "lombok",
        description:
          "Java annotation library which helps to reduce boilerplate code.",
      },
    ],
  },
  {
    category: "Web",
    items: [
      {
        label: "Spring Web",
        value: "web",
        description:
          "Build web, including RESTful, applications using Spring MVC. Uses Apache Tomcat as the default embedded container.",
      },
      {
        label: "Spring Web Services",
        value: "web-services",
        description:
          "Facilitates contract-first SOAP development. Allows for the creation of flexible web services using one of the many ways to manipulate XML payloads.",
      },
      {
        label: "Spring for GraphQL",
        value: "graphql",
        description:
          "Build GraphQL applications with Spring for GraphQL and GraphQL Java.",
      },
      {
        label: "Rest Repositories HAL Explorer",
        value: "data-rest-explorer",
        description: "Browsing Spring Data REST repositories in your browser.",
      },
      {
        label: "Vaadin",
        value: "vaadin",
        description:
          "The full-stack web app platform for Spring. Build views fully in Java with Flow, or in React using Hilla.",
      },
      {
        label: "Hilla",
        value: "hilla",
        description:
          "building reactive web applications, integrating a Spring Boot Java backend with a TypeScript frontend using React.",
      },
      {
        label: "Data Rest",
        value: "data-rest",
        description:
          "Exposing Spring Data repositories over REST via Spring Data REST.",
      },
      {
        label: "Spring Session",
        value: "session",
        description:
          "Provides an API and implementations for managing user session information.",
      },
      {
        label: "Webflux",
        value: "webflux",
        description:
          "Build reactive web applications with Spring WebFlux and Netty.",
      },
      {
        label: "jersey",
        value: "jersey",
        description:
          "Framework for developing RESTful Web Services in Java that provides support for JAX-RS APIs.",
      },
      {
        label: "Spring HATEOAS",
        value: "hateoas",
        description:
          "Eases the creation of RESTful APIs that follow the HATEOAS principle when working with Spring / Spring MVC.",
      },
    ],
  },
  {
    category: "Observability",
    items: [
      {
        label: "Dynatrace",
        value: "dynatrace",
        description:
          "Publish Micrometer metrics to Dynatrace, a platform featuring observability, AIOps, application security and analytics.",
      },
      {
        label: "Zipkin",
        value: "zipkin",
        description: "Enable and expose span and trace IDs to Zipkin.",
      },
      {
        label: "Datadog",
        value: "datadog",
        description:
          "Publish Micrometer metrics to Datadog, a dimensional time-series SaaS with built-in dashboarding and alerting.",
      },
      {
        label: "New Relic",
        value: "new-relic",
        description:
          "Publish Micrometer metrics to New Relic, a SaaS offering with a full UI and a query language called NRQL.",
      },
      {
        label: "Distributed Tracing",
        value: "distributed-tracing",
        description: "Enable span and trace IDs in logs.",
      },
      {
        label: "Graphite",
        value: "graphite",
        description:
          "Publish Micrometer metrics to Graphite, a hierarchical metrics system backed by a fixed-size database.",
      },
      {
        label: "Wavefront",
        value: "wavefront",
        description:
          "Publish metrics and optionally distributed traces to Tanzu Observability by Wavefront, a SaaS-based metrics monitoring and analytics platform that lets you visualize, query, and alert over data from across your entire stack.",
      },
      {
        label: "Prometheus",
        value: "prometheus",
        description:
          "Expose Micrometer metrics in Prometheus format, an in-memory dimensional time series database with a simple built-in UI, a custom query language, and math operations.",
      },
      {
        label: "Influx",
        value: "influx",
        description:
          "Publish Micrometer metrics to InfluxDB, a dimensional time-series server that support real-time stream processing of data.",
      },
    ],
  },
  {
    category: "Ops",
    items: [
      {
        label: "Spring Boot Actuator",
        value: "actuator",
        description:
          "Supports built in (or custom) endpoints that let you monitor and manage your application - such as application health, metrics, sessions, etc.",
      },
      {
        label: "codecentric's Spring Boot Admin (Client)",
        value: "codecentric-spring-boot-admin-client",
        description:
          "Required for your application to register with a Codecentric's Spring Boot Admin Server instance.",
      },
      {
        label: "codecentric's Spring Boot Admin (Server)",
        value: "codecentric-spring-boot-admin-server",
        description:
          "A community project to manage and monitor your Spring Boot applications. Provides a UI on top of the Spring Boot Actuator endpoints.",
      },
      {
        label: "Sentry",
        value: "sentry",
        description:
          "Application performance monitoring and error tracking that help software teams see clearer, solve quicker, and learn continuously.",
      },
    ],
  },
  {
    category: "SQL",
    items: [
      {
        label: "SQL Server",
        value: "sqlserver",
        description:
          "A JDBC and R2DBC driver that provides access to Microsoft SQL Server and Azure SQL Database from any Java application.",
      },
      {
        label: "MySQL",
        value: "mysql",
        description: "MySQL JDBC driver.",
      },
      {
        label: "PostgreSQL",
        value: "postgresql",
        description:
          "A JDBC and R2DBC driver that allows Java programs to connect to a PostgreSQL database using standard, database independent Java code.",
      },
      {
        label: "HyperSQL Database",
        value: "hsql",
        description: "Lightweight 100% Java SQL Database Engine.",
      },
      {
        label: "IBM DB2 Driver",
        value: "db2",
        description: "A JDBC driver that provides access to IBM DB2.",
      },
      {
        label: "Liquibase Migration",
        value: "liquibase",
        description: "Liquibase database migration and source control library.",
      },
      {
        label: "Apache Derby Database",
        value: "derby",
        description:
          "An open source relational database implemented entirely in Java.",
      },
      {
        label: "Oracle",
        value: "oracle",
        description: "A JDBC driver that provides access to Oracle.",
      },
      {
        label: "Flyway Migration",
        value: "flyway",
        description:
          "Version control for your database so you can migrate from any version (incl. an empty database) to the latest version of the schema.",
      },
      {
        label: "Spring Data JPA",
        value: "data-jpa",
        description:
          "Persist data in SQL stores with Java Persistence API using Spring Data and Hibernate.",
      },
      {
        label: "Spring Data JDBC",
        value: "data-jdbc",
        description:
          "Persist data in SQL stores with plain JDBC using Spring Data.",
      },
      {
        label: "MyBatis Framework",
        value: "mybatis",
        description:
          "Persistence framework with support for custom SQL, stored procedures and advanced mappings. MyBatis couples objects with stored procedures or SQL statements using a XML descriptor or annotations.",
      },
      {
        label: "Spring Data R2DBC",
        value: "data-r2dbc",
        description:
          "Provides Reactive Relational Database Connectivity to persist data in SQL stores using Spring Data in reactive applications.",
      },
      {
        label: "JDBC",
        value: "jdbc",
        description:
          "Java API to connect and execute the query with the database. ",
      },
      {
        label: "H2 Database",
        value: "h2",
        description:
          "Provides a fast in-memory database that supports JDBC API and R2DBC access, with a small (2mb) footprint. Supports embedded and server modes as well as a browser based console application.",
      },
      {
        label: "JOOQ",
        value: "jooq",
        description:
          "Generate Java code from your database and build type safe SQL queries through a fluent API.",
      },
      {
        label: "MariaDB",
        value: "mariadb",
        description: "MariaDB JDBC and R2DBC driver.",
      },
    ],
  },
  {
    category: "NoSQL",
    items: [
      {
        label: "Spring Data Reactive Redis",
        value: "data-redis-reactive",
        description:
          "Access Redis key-value data stores in a reactive fashion with Spring Data Redis.",
      },
      {
        label: "Spring Data for Apache Cassandra",
        value: "cassandra",
        description:
          "A free and open-source, distributed, NoSQL database management system that offers high-scalability and high-performance.",
      },
      {
        label: "Spring Data Reactive for Apache Cassandra",
        value: "data-cassandra-reactive",
        description: "Access Cassandra NoSQL Database in a reactive fashion.",
      },
      {
        label: "Spring Data Reactive Couchbase",
        value: "data-couchbase-reactive",
        description:
          "Access Couchbase NoSQL database in a reactive fashion with Spring Data Couchbase.",
      },
      {
        label: "Spring Data Neo4j",
        value: "data-neo4j",
        description:
          "An open source NoSQL database that stores data structured as graphs consisting of nodes, connected by relationships.",
      },
      {
        label: "Spring Data Couchbase",
        value: "data-couchbase",
        description:
          "NoSQL document-oriented database that offers in memory-first architecture, geo-distributed deployments, and workload isolation.",
      },
      {
        label: "Spring Data Redis (Access+Driver)",
        value: "data-redis",
        description:
          "Advanced and thread-safe Java Redis client for synchronous, asynchronous, and reactive usage. Supports Cluster, Sentinel, Pipelining, Auto-Reconnect, Codecs and much more.",
      },
      {
        label: "Spring Data MongoDB",
        value: "data-mongodb",
        description:
          "Store data in flexible, JSON-like documents, meaning fields can vary from document to document and data structure can be changed over time.",
      },
      {
        label: "Spring Data Reactive MongoDB",
        value: "data-mongodb-reactive",
        description:
          "Provides asynchronous stream processing with non-blocking back pressure for MongoDB.",
      },
      {
        label: "Spring Data Elasticsearch (Access+Driver)",
        value: "data-elasticsearch",
        description:
          "A distributed, RESTful search and analytics engine with Spring Data Elasticsearch.",
      },
    ],
  },
  {
    category: "Messaging",
    items: [
      {
        label: "Apache Camel",
        value: "camel",
        description:
          "Apache Camel is an open source integration framework that empowers you to quickly and easily integrate various systems consuming or producing data.",
      },
      {
        label: "Spring for Apache Kafka",
        value: "kafka",
        description:
          "Publish, subscribe, store, and process streams of records.",
      },
      {
        label: "Spring for Apache Kafka Streams",
        value: "kafka-streams",
        description:
          "Building stream processing applications with Apache Kafka Streams.",
      },
      {
        label: "Spring Integration",
        value: "integration",
        description:
          "Adds support for Enterprise Integration Patterns. Enables lightweight messaging and supports integration with external systems via declarative adapters.",
      },
      {
        label: "Spring for Apache Pulsar (Reactive)",
        value: "pulsar-reactive",
        description: "Build reactive messaging applications with Apache Pulsar",
      },
      {
        label: "Spring for Apache ActiveMQ 5",
        value: "activemq",
        description: "Spring JMS support with Apache ActiveMQ 'Classic'.",
      },
      {
        label: "AMQP",
        value: "amqp",
        description:
          "open standard wire specification for asynchronous message communication. It provides a description of how a message should be constructed.",
      },
      {
        label: "RSocket",
        value: "rsocket",
        description: "RSocket.io applications with Spring Messaging and Netty.",
      },
      {
        label: "Solace",
        value: "solace",
        description:
          "Connect to a Solace PubSub+ Advanced Event Broker to publish, subscribe, request/reply and store/replay messages",
      },
      {
        label: "WebSocket",
        value: "websocket",
        description:
          "Build Servlet-based WebSocket applications with SockJS and STOMP.",
      },
      {
        label: "Pulsar",
        value: "pulsar",
        description: "Cloud-Native, Distributed Messaging and Streaming.",
      },
      {
        label: "Artemis",
        value: "artemis",
        description: "Spring JMS support with Apache ActiveMQ Artemis.",
      },
    ],
  },
  {
    category: "Testing",
    items: [
      {
        label: "Cloud Contract Stub Runner",
        value: "cloud-contract-stub-runner",
        description:
          "Stub Runner for HTTP/Messaging based communication. Allows creating WireMock stubs from RestDocs tests.",
      },
      {
        label: "Testcontainers",
        value: "testcontainers",
        description:
          "Provide lightweight, throwaway instances of common databases, Selenium web browsers, or anything else that can run in a Docker container.",
      },
      {
        label: "Unboundid LDAP",
        value: "unboundid-ldap",
        description:
          "Provides a platform neutral way for running a LDAP server in unit tests.",
      },
      {
        label: "Cloud Contract Verifier",
        value: "cloud-contract-verifier",
        description:
          "Moves TDD to the level of software architecture by enabling Consumer Driven Contract (CDC) development.",
      },
      {
        label: "Spring REST Docs",
        value: "restdocs",
        description:
          "Document RESTful services by combining hand-written with Asciidoctor and auto-generated snippets produced with Spring MVC Test.",
      },
    ],
  },
  {
    category: "I/O",
    items: [
      {
        label: "Validation",
        value: "validation",
        description: "Bean Validation with Hibernate validator.",
      },
      {
        label: "Spring Cache Abstraction",
        value: "cache",
        description:
          "Provides cache-related operations, such as the ability to update the content of the cache, but does not provide the actual data store.",
      },
      {
        label: "Spring Shell",
        value: "spring-shell",
        description: "Build command line applications with spring.",
      },
      {
        label: "Java Mail Sender",
        value: "mail",
        description:
          "Send email using Java Mail and Spring Framework's JavaMailSender.",
      },
      {
        label: "Spring Batch",
        value: "batch",
        description:
          "Batch applications with transactions, retry/skip and chunk based processing.",
      },
      {
        label: "Quartz Scheduler",
        value: "quartz",
        description: "Schedule jobs using Quartz.",
      },
    ],
  },
  {
    category: "Microsoft Azure",
    items: [
      {
        label: "Azure Support",
        value: "azure-support",
        description:
          "Auto-configuration for Azure Services (Service Bus, Storage, Active Directory, Key Vault, and more).",
      },
      {
        label: "Azure Key Vault",
        value: "azure-keyvault",
        description:
          "All key vault features are supported, e.g. manage application secrets and certificates.",
      },
      {
        label: "Azure Active Directory",
        value: "azure-active-directory",
        description:
          "Spring Security integration with Azure Active Directory for authentication.",
      },
      {
        label: "Azure Cosmos DB",
        value: "azure-cosmos-db",
        description:
          "Fully managed NoSQL database service for modern app development, including Spring Data support.",
      },
      {
        label: "Azure Storage",
        value: "azure-storage",
        description:
          "All Storage features are supported, e.g. blob, fileshare and queue.",
      },
    ],
  },
  {
    category: "Spring Cloud",
    items: [
      {
        label: "Cloud Bootstrap",
        value: "cloud-starter",
        description:
          "Non-specific Spring Cloud features, unrelated to external libraries or integrations (e.g. Bootstrap context and @RefreshScope).",
      },
      {
        label: "Config Server",
        value: "cloud-config-server",
        description:
          "Central management for configuration via Git, SVN, or HashiCorp Vault.",
      },
      {
        label: "Cloud Task",
        value: "cloud-task",
        description:
          "Allows a user to develop and run short lived microservices using Spring Cloud. Run them locally, in the cloud, and on Spring Cloud Data Flow.",
      },
      {
        label: "Cloud Function",
        value: "cloud-function",
        description:
          "Promotes the implementation of business logic via functions and supports a uniform programming model across serverless providers, as well as the ability to run standalone (locally or in a PaaS).",
      },
    ],
  },
  {
    category: "Spring Cloud Config",
    items: [
      {
        label: "Apache Zookeeper Configuration",
        value: "cloud-starter-zookeeper-config",
        description:
          "Enable and configure common patterns inside your application and build large distributed systems with Apache Zookeeper based components. The provided patterns include Service Discovery and Configuration.",
      },
      {
        label: "Config Server",
        value: "cloud-config-server",
        description:
          "Central management for configuration via Git, SVN, or HashiCorp Vault.",
      },
      {
        label: "Consul Configuration",
        value: "cloud-starter-consul-config",
        description:
          "Enable and configure the common patterns inside your application and build large distributed systems with Hashicorp’s Consul. The patterns provided include Service Discovery, Distributed Configuration and Control Bus.",
      },
      {
        label: "Vault Configuration",
        value: "cloud-starter-vault-config",
        description:
          "Provides client-side support for externalized configuration in a distributed system. Using HashiCorp's Vault you have a central place to manage external secret properties for applications across all environments.",
      },
      {
        label: "Cloud Config Client",
        value: "cloud-config-client",
        description:
          "Client that connects to a Spring Cloud Config Server to fetch the application's configuration.",
      },
    ],
  },
  {
    category: "Spring Cloud Discovery",
    items: [
      {
        label: "Consul Discovery",
        value: "cloud-starter-consul-discovery",
        description: "Service discovery with Hashicorp Consul.",
      },
      {
        label: "Cloud Eureka",
        value: "cloud-eureka",
        description:
          "A REST based service for locating services for the purpose of load balancing and failover of middle-tier servers.",
      },
      {
        label: "Apache Zookeeper Discovery",
        value: "cloud-starter-zookeeper-discovery",
        description: "Service discovery with Apache Zookeeper.",
      },
      {
        label: "Cloud Eureka Server",
        value: "cloud-eureka-server",
        description: "spring-cloud-netflix Eureka Server.",
      },
    ],
  },
  {
    category: "Spring Cloud Messaging",
    items: [
      {
        label: "Cloud Bus",
        value: "cloud-bus",
        description:
          "Links nodes of a distributed system with a lightweight message broker which can used to broadcast state changes or other management instructions (requires a binder, e.g. Apache Kafka or RabbitMQ).",
      },
      {
        label: "Cloud Stream",
        value: "cloud-stream",
        description:
          "Framework for building highly scalable event-driven microservices connected with shared messaging systems (requires a binder, e.g. Apache Kafka, Apache Pulsar, RabbitMQ, or Solace PubSub+).",
      },
    ],
  },
  {
    category: "Spring Cloud Circuit Breaker",
    items: [
      {
        label: "Resilience4J",
        value: "cloud-resilience4j",
        description:
          "Spring Cloud Circuit breaker with Resilience4j as the underlying implementation.",
      },
    ],
  },
  {
    category: "Spring Cloud Routing",
    items: [
      {
        label: "Cloud LoadBalancer",
        value: "cloud-loadbalancer",
        description:
          "Client-side load-balancing with Spring Cloud LoadBalancer.",
      },
      {
        label: "Cloud Gateway",
        value: "cloud-gateway",
        description:
          "Provides a simple, yet effective way to route to APIs in Servlet-based applications. Provides cross-cutting concerns to those APIs such as security, monitoring/metrics, and resiliency.",
      },
      {
        label: "Cloud Feign",
        value: "cloud-feign",
        description:
          "Declarative REST Client. OpenFeign creates a dynamic implementation of an interface decorated with JAX-RS or Spring MVC annotations.",
      },
    ],
  },
  {
    category: "Security",
    items: [
      {
        label: "OAuth2 Authorization Server",
        value: "oauth2-authorization-server",
        description: "Spring Boot integration for Spring Authorization Server.",
      },
      {
        label: "OAuth2 Client",
        value: "oauth2-client",
        description:
          "Spring Boot integration for Spring Security's OAuth2/OpenID Connect client features.",
      },
      {
        label: "Data LDAP",
        value: "data-ldap",
        description:
          "Makes it easier to build Spring based applications that use the Lightweight Directory Access Protocol.",
      },
      {
        label: "Okta",
        value: "okta",
        description:
          "Okta specific configuration for Spring Security/Spring Boot OAuth2 features. Enable your Spring Boot application to work with Okta via OAuth 2.0/OIDC.",
      },
      {
        label: "Spring Security",
        value: "security",
        description:
          "Highly customizable authentication and access-control framework for Spring applications.",
      },
      {
        label: "OAuth2 Resource Server",
        value: "oauth2-resource-server",
        description:
          "Spring Boot integration for Spring Security's OAuth2 resource server features.",
      },
    ],
  },
  {
    category: "VMware Tanzu Application Service",
    items: [
      {
        label: "SCS config client",
        value: "scs-config-client",
        description: "Config client on VMware Tanzu Application Service.",
      },
      {
        label: "SCS Service Registry",
        value: "scs-service-registry",
        description:
          "Eureka service discovery client on VMware Tanzu Application Service.",
      },
    ],
  },
  {
    category: "Google Cloud",
    items: [
      {
        label: "Cloud GCP",
        value: "cloud-gcp",
        description:
          "Contains auto-configuration support for every Google Cloud integration. Most of the auto-configuration code is only enabled if other dependencies are added to the classpath.",
      },
      {
        label: "Cloud GCP pubsub",
        value: "cloud-gcp-pubsub",
        description:
          "Adds the Google Cloud Support entry and all the required dependencies so that the Google Cloud Pub/Sub integration work out of the box.",
      },
      {
        label: "Cloud GCP Storage",
        value: "cloud-gcp-storage",
        description:
          "Adds the Google Cloud Support entry and all the required dependencies so that the Google Cloud Storage integration work out of the box.",
      },
    ],
  },
  {
    category: "Template Engines",
    items: [
      {
        label: "Apache Freemarker",
        value: "freemarker",
        description:
          "Java library to generate text output (HTML web pages, e-mails, configuration files, source code, etc.) based on templates and changing data.",
      },
      {
        label: "Groovy Templates",
        value: "groovy-templates",
        description: "Groovy templating engine.",
      },
      {
        label: "Thymeleaf",
        value: "thymeleaf",
        description:
          "A modern server-side Java template engine for both web and standalone environments. Allows HTML to be correctly displayed in browsers and as static prototypes.",
      },
      {
        label: "Mustache",
        value: "mustache",
        description:
          "Logic-less templates for both web and standalone environments. There are no if statements, else clauses, or for loops. Instead there are only tags.",
      },
    ],
  },
];
